import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export default function CategoryGrid({ categories }) {
  return (
    <section data-testid="categories-section" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <SectionHeading
        index="01"
        overline="Browse"
        title="Shop by Category"
        sub="Eight considered collections covering every corner of your day — from the kitchen shelf to the gym bag."
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {categories.map((cat, i) => (
          <Reveal key={cat.slug} delay={(i % 4) * 0.07}>
            <Link
              to={`/shop?category=${cat.slug}`}
              data-testid={`category-card-${cat.slug}`}
              className="group relative block aspect-[4/5] overflow-hidden rounded-xl img-frame"
            >
              <img
                src={cat.image}
                alt={cat.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.07]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5">
                <h3 className="font-heading text-sm font-bold leading-tight text-white sm:text-base">{cat.name}</h3>
                <p className="mt-0.5 hidden text-xs text-white/60 sm:block">{cat.tagline}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-white/90 transition-all duration-300 group-hover:gap-2">
                  Shop Now <ArrowUpRight size={13} />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
